import React, {useState, createRef, useEffect} from 'react';
import dateformat from 'dateformat';
import CalendarBlock from '../../../../../../../myaccount/src/stories/components/Wallet/RightBlock/WalletStatement/WalletCalendar';

import * as S from './TextInput.styles';
import * as C from '../../../OnboardingNew/Common.styles';

const TextInput = ({
  labelText,
  placeholder,
  haserror,
  classes,
  inputType = 'text',
  endIcon,
  mobileNumber,
  setterObj,
  setterFunction,
  name,
  component,
  type,
  showOnlyUaeNumber,
  countryCode,
  setCountryCode,
  stringValue,
  setMargin = true,
  withoutLabel = false,
  disabled,
  allowPastDate = true,
}) => {
  const startDateRef = createRef();
  const listRef = createRef();
  const dateString =
    stringValue && type === 'Date' ? Date.parse(dateformat(stringValue, 'yyyy-mm-dd')) : '';

  const [calendarMode, setCalendarMode] = useState('start');
  const [showDate, setShowDate] = useState(false);
  const [fieldType, setFieldType] = useState(inputType);
  const [value, setValue] = useState(stringValue ? stringValue : '');
  const [walletStatementDates, setDates] = useState(
    stringValue && type === 'Date' ? {startDate: new Date(dateString)} : {},
  );
  const [calenderHandle, setCalenderHandle] = useState(false);

  const viewPassword = () => setFieldType(fieldType === 'text' ? 'password' : 'text');

  useEffect(() => {
    setValue(stringValue);
  }, [stringValue]);

  const inputChangeHandler = e => {
    if (e.target.name === 'mobile') {
      const val = e.target.value;
      if (val && !Number(val)) return;
      if (e.target.value?.length > 9) return;
    }
    if (component === 'passportUploadDetails' || component === 'businessUploadDetails') {
      const obj = setterObj;
      obj[e.target.name] = e.target.value;
      if (e.target.name === 'surname' || e.target.name === 'givenName') {
        obj['fullName'] = obj['givenName'] + ' ' + obj['surname'];
      }
      setterFunction({...obj});
    } else {
      setterFunction(e.target.value);
    }
    setValue(e.target.value);
  };

  const updateQueryCaller = data => {
    if (data.startDate) {
      setDates({
        startDate: data.startDate,
        //endDate: data.endDate
      });
      const obj = setterObj;
      obj[name] = `${dateformat(data.startDate, 'yyyy-mm-dd')}`;
      setterFunction({...obj});
    }
    setShowDate(!showDate);
    setCalenderHandle(!calenderHandle);
  };

  const showDateHandler = () => {
    setShowDate(!showDate);
    setCalenderHandle(!calenderHandle);
  };

  const handleDropdownSelection = e => {
    if (e.target.value) {
      setCountryCode(e.target.value);
    } else {
      return;
    }
  };

  return (
    <S.InputContainer setMargin={setMargin}>
      <label>{labelText}</label>
      <S.InputWrapper extrapadding={mobileNumber} withoutLabel={withoutLabel}>
        {mobileNumber && (
          <S.FlagCont>
            <S.Flag>
              <img src="https://assets-gos3.goibibo.com/myp_UAE_Flag-1673868146.png" alt="flag" />
            </S.Flag>
            <S.Code>+971</S.Code>
          </S.FlagCont>
        )}
        {endIcon && <span className={`${endIcon}`} onClick={viewPassword}></span>}
        {type !== 'Date' ? (
          <input
            value={value}
            onChange={inputChangeHandler}
            type={fieldType}
            placeholder={placeholder}
            haserror={haserror}
            name={name}
            disabled={disabled}
            //className={`${classes}`}
          />
        ) : (
          <S.StatementTimeWrap onClick={showDateHandler}>
            <S.StatementTimeInnerWrap>
              <S.FromTimeWrap>
                <S.FromTimeMainText>
                  {walletStatementDates?.startDate
                    ? dateformat(walletStatementDates?.startDate, 'dd/mm/yyyy')
                    : 'Select Date'}
                </S.FromTimeMainText>
              </S.FromTimeWrap>
              {showDate && calenderHandle && (
                <S.CalendarWrapperFrom>
                  <CalendarBlock
                    ref={startDateRef}
                    isSearchWidget={true}
                    isStartMode={calendarMode === 'start'}
                    onSelection={() => setCalendarMode('start')}
                    updateQueryCaller={updateQueryCaller}
                    showMaxEndDate={true}
                    startDate={walletStatementDates.startDate ? walletStatementDates.startDate : ''}
                    isSingleDateMode={true}
                    allowPastDate={allowPastDate}
                  />
                </S.CalendarWrapperFrom>
              )}
            </S.StatementTimeInnerWrap>
          </S.StatementTimeWrap>
        )}
      </S.InputWrapper>
    </S.InputContainer>
  );
};

export default TextInput;
